import { render } from "./SepaComponent.vue?vue&type=template&id=5260c606&scoped=true"
import script from "./SepaComponent.vue?vue&type=script&lang=js"
export * from "./SepaComponent.vue?vue&type=script&lang=js"

import "./SepaComponent.vue?vue&type=style&index=0&id=5260c606&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5260c606"]])

export default __exports__